/** 明细：始终千分位精确展示 */
export function formatTokensExact(value: number): string {
  return value.toLocaleString('zh-CN');
}

/** 汇总：小于 1 万用千分位；≥1 万用「万」；≥1 亿用「亿」。 */
export function formatTokensCompact(value: number): string {
  if (!Number.isFinite(value)) return String(value);
  const n = Math.round(value);
  if (Math.abs(n) < 10_000) return n.toLocaleString('zh-CN');
  if (Math.abs(n) < 100_000_000) return `${trimOneDecimal(n / 10_000)}万`;
  return `${trimOneDecimal(n / 100_000_000)}亿`;
}

function trimOneDecimal(value: number): string {
  const fixed = Math.abs(value) >= 100 ? value.toFixed(0) : value.toFixed(1);
  return fixed.replace(/\.0$/, '');
}
